var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('el-button',_vm._b({},'el-button',_vm.schema,false),[_vm._v(" "+_vm._s(_vm.schema.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }